import { Box, Divider, Paper, Rating, Stack, Typography } from "@mui/material";
import type { ReviewDetails } from "../types";
import { format } from "utils";

interface ReviewTabProps {
  selectedReview: ReviewDetails;
  merchantName?: string;
}

const ReviewTab = ({ selectedReview, merchantName }: ReviewTabProps) => {
  const { userName, gender, tripTitle, rating, reviews, createdAt, updatedAt } =
    selectedReview;

  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        bgcolor: "background.default",
        borderRadius: 2,
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      {/* User Info */}
      <Box mb={2}>
        <Typography variant="h6" fontWeight={600}>
          {userName} {gender && `(${gender})`}
        </Typography>
        <Typography variant="body1" mt={2} color="text.secondary">
          Trip: {tripTitle || "—"}
        </Typography>
        {merchantName && (
          <Typography variant="body1" color="text.secondary">
            Merchant: {merchantName}
          </Typography>
        )}
      </Box>

      <Divider sx={{ my: 2 }} />

      {/* Ratings Section */}
      <Box mb={2}>
        <Typography variant="subtitle1" fontWeight={600}>
          Ratings
        </Typography>
        <Stack direction="row" spacing={4} mt={1}>
          <Stack alignItems="center">
            <Typography variant="caption">Host</Typography>
            <Rating value={rating.host} readOnly precision={0.5} />
          </Stack>
          <Stack alignItems="center">
            <Typography variant="caption">Merchant</Typography>
            <Rating value={rating.merchant} readOnly precision={0.5} />
          </Stack>
          <Stack alignItems="center">
            <Typography variant="caption">Trip</Typography>
            <Rating value={rating.trip} readOnly precision={0.5} />
          </Stack>
        </Stack>
      </Box>

      <Divider sx={{ my: 2 }} />

      {/* Comments Section */}
      <Box mb={2}>
        <Typography variant="subtitle1" fontWeight={600}>
          Review Comments
        </Typography>

        <Stack spacing={1} mt={1}>
          <Typography variant="body2">
            <strong>Host:</strong> {reviews.host || "—"}
          </Typography>
          <Typography variant="body2">
            <strong>Merchant:</strong> {reviews.merchant || "—"}
          </Typography>
          <Typography variant="body2">
            <strong>Trip:</strong> {reviews.trip || "—"}
          </Typography>
        </Stack>
      </Box>

      <Divider sx={{ my: 2 }} />

      {/* Timestamps */}
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="caption" fontSize={14} color="text.secondary">
          Created: {format(createdAt)}
        </Typography>
        <Typography variant="caption" fontSize={14} color="text.secondary">
          Updated: {format(updatedAt)}
        </Typography>
      </Stack>
    </Paper>
  );
};

export default ReviewTab;
